interface POSProps {
  value: string;
}

/**
 * Part-of-speech pill. Italic serif, sentence-case, hair border — looks
 * like an inline dictionary annotation.
 */
export function POS({ value }: POSProps) {
  return <span className="pill pill-pos">{value}</span>;
}
